import { Fields } from './types';

export const sortFields = [
    Fields.INVOICE_REASON,
    Fields.INVOICE_DATE,
    Fields.TOTAL_REDUCTION,
    Fields.NET_TOTAL,
    Fields.STATUS,
];
